import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Core Schema
// ============================================================================
const TitlingServiceConfigSchema = serviceConfigSchema;
// ============================================================================
// DTO Schema
// ============================================================================
const TitlingServiceConfigDtoSchema = serviceConfigSchema;

export { TitlingServiceConfigDtoSchema, TitlingServiceConfigSchema };
//# sourceMappingURL=TitlingServiceConfig.js.map
